import { useQueryClient } from "@tanstack/react-query"
import { NOTIFICATION_PREFERENCE_EVENT_NAMES } from "@zplanem/responses"
import { useCallback } from "react"
import { queryKeys } from "../../lib/query-keys"
import { usePerUserChannelEvents } from "./use-per-user-channel-event"

export function useNotificationPreferenceInvalidation(
	userId: string | undefined,
): void {
	const queryClient = useQueryClient()
	const handler = useCallback(() => {
		void queryClient.invalidateQueries({
			queryKey: queryKeys.notificationPreferences(),
		})
	}, [queryClient])

	usePerUserChannelEvents(userId, NOTIFICATION_PREFERENCE_EVENT_NAMES, handler)
}
